export const pageData = {
  badge: "Replay",
  title: 'Talk "Costruire una now-next talent strategy" 25 febbraio 2026 – Skillvue',
  video: {
    thumbnail: "https://customer-assets.emergentagent.com/job_page-recreate-1/artifacts/yfoomgm2_Screenshot%202026-02-26%20at%2011.49.18.png",
    channel: "Skillvue",
    duration: "48:42",
    watchUrl: "#"
  },
  paragraphs: [
    {
      text: 'Gartner è chiaro: <strong>tra le priorità HR per il 2026 c\'è costruire una strategia "now–next"</strong>, capace di rispondere alle esigenze operative immediate e, allo stesso tempo, preparare l\'organizzazione al lavoro che verrà.',
      type: "normal"
    },
    {
      text: "Nella GDO questo si traduce in una serie di domande concrete, non solo per HR ma anche (e soprattutto per il business): come capire meglio e prima chi assumere, chi far crescere, chi è pronto per il ruolo successivo?",
      type: "normal"
    },
    {
      text: "<strong>Domande che valgono milioni all'anno</strong>, risolte ancora troppo spesso con colloqui disomogenei, intuizioni e opinioni soggettive mentre tutto il resto del business è già guidato dai dati.",
      type: "normal"
    },
    {
      text: "<strong>Domande alle quali abbiamo risposto</strong> mercoledì 25 febbraio alle 12.00 insieme a",
      type: "normal"
    }
  ],
  speakers: [
    {
      name: "Simone Patera",
      role: "Co-founder — Skillvue"
    },
    {
      name: "Mirko Tortolano",
      role: "Direttore del Personale — In's Mercato"
    },
    {
      name: "Mariam Es Saadi",
      role: "Responsabile Selezione, Sviluppo e Formazione — In's Mercato"
    },
    {
      name: "Mario Casillo",
      role: "Senior Account Executive - Skillvue"
    }
  ],
  afterSpeakers: "Scoprendo come un'azienda con <strong>4.200 dipendenti e 570+ punti vendita</strong> sul territorio sia riuscita a cambiare l'equazione, con tutto ciò che questo ha comportato da un punto di vista di metriche e risultati, ma anche rapporto con le persone, tra soddisfazioni e lezioni imparate per il futuro.",
  keyTopics: [
    {
      title: 'La strategia "Now–Next"',
      description: "Come coprire le posizioni vacanti oggi e costruire la pipeline di Store Manager per domani senza rincorrere il fabbisogno all'ultimo minuto e abbattendo il turnover."
    },
    {
      title: "La scala: 1.000 persone, un metodo unico",
      description: "Come valutare una popolazione ampia in modo oggettivo, eliminando il bias territoriale e le dinamiche di segnalazione interna."
    },
    {
      title: "L'impatto culturale",
      description: "Perché le persone tornavano in negozio a raccontare l'esperienza ai colleghi. Come un processo di valutazione diventa leva di employer branding interno."
    },
    {
      title: "La trasformazione a 360°",
      description: "Cosa possiamo imparare da chi non ha semplicemente integrato un nuovo sistema di valutazione delle competenze, ma lo ha sfruttato come leva strategica per integrare selezione, sviluppo e formazione in un ciclo continuo di vera preparazione al futuro del lavoro."
    }
  ]
};
